import type { ExperimentConfig } from '../@types'

// A/B — DEV-35256. Age-consistent flow imagery on activity-female-walking for all traffic
// (US + non-US), the experiment counterpart of the DEV-34984 affiliate roll-out.
//
// Only ONE element: `getAppAreaExperiment` (src/funnels/funnels.ts:213) maps variant 0 AND
// variant 1 to element [0], so control loads the experimental funnel too — deliberately.
// The split happens INSIDE it, on the `featureKey == / != web_f_walking_age_imagery` screen
// pairs cloned from the parent funnel: `resolveFeatureFlag` falls through to
// `Boolean($absmartly.treatment('web_f_walking_age_imagery'))`, so control gets the default
// illustrations and B the age-matched photography. That condition is also what registers the
// exposure — the `funnel` branch of `getAppAreaExperiment` never calls `treatment()` itself.
//
// The key must NOT be added to `runtime/external/featureFlags.ts`: a local resolver there
// short-circuits before the ABsmartly fallback and would pin both arms to one variant.
//
// The audience must exclude `utm_source ~ influencer` — that cohort already gets the imagery
// from the parent funnel's `influencer_traffic` gate and would land in control seeing treatment.
const config: ExperimentConfig[] = [
	{
		'activity-female-walking': {
			// /walking-f?safe&mock-data&utm_source=FB&country=US&area=activity-female-walking&exp=web_f_walking_age_imagery~1
			funnel: {
				id: 'ob-female-activity-walking-age-imagery',
				locale: ['en', 'de-DE', 'fr-FR', 'tr', 'sv', 'pl', 'pt-BR', 'it-IT', 'es-ES', 'es-419', 'da', 'nb', 'nl', 'ja'],
			},
		},
	},
]

export default config
